import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { Product } from '../models/product';
import { convertSnaps } from './db-utils';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private angularFirestore: AngularFirestore) { }

  loadAllProducts(): Observable<Product[]> {
    return this.angularFirestore.collection('products')
                .snapshotChanges()
        .pipe(map(snaps => convertSnaps<Product>(snaps))
        , first()); // Con first Se asegura que el observable es completado entonces solo trae los datos una vez 
  }


  getProductById(id: string): Observable<Product> {
    return this.angularFirestore.doc<Product>(`products/${id}`)
        .snapshotChanges()
        .pipe(map(snaps => {
           return {
            id: snaps.payload.id,
            ...snaps.payload.data()
          };
        }), first());
  }

  getProducts(category: string): Observable<Product[]>{
    return this.angularFirestore.collection('products',
      ref => ref.where('categories', 'array-contains', category))
        .snapshotChanges()
        .pipe(
          map(snaps => convertSnaps<Product>(snaps))
          , first());
  }


}
